import { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocationNews, useGeneralNews } from "../api/index";
import { LocationContext } from "../utilities/LocationContext";
import { NewsNotificationContext } from "../utilities/NewsNotificationContext";

console.log("[NewsNotificationChecker] MODULE LOADED");

const NewsNotificationChecker = () => {
  console.log("[NewsNotificationChecker] RENDER");
  const { i18n } = useTranslation();
  const { selectedLocation } = useContext(LocationContext);
  const { checkForNewNews } = useContext(NewsNotificationContext);

  const location = selectedLocation?.sharepointNewsSource;
  const locationId = selectedLocation?.id;
  const language = i18n.language || "fi";

  // Fetch location-specific news
  const locationNews = useLocationNews({
    startRow: 0,
    location,
    language,
  });

  // Fetch general news
  const generalNews = useGeneralNews({
    startRow: 0,
    language,
  });

  // Check for new news when data is loaded
  useEffect(() => {
    console.log("[NewsNotificationChecker]", {
      locationId,
      locationNewsCount: locationNews?.length,
      generalNewsCount: generalNews?.length,
      sampleIds: generalNews?.slice(0, 3).map((n) => n.id),
    });
    console.log("[NewsNotificationChecker] effect running", {
      locationId,
      locationNewsLength: locationNews?.length,
      generalNewsLength: generalNews?.length,
      locationNewsValue: locationNews,
      generalNewsValue: generalNews,
    });

    if (!locationId) {
      console.log("[NewsNotificationChecker] no locationId, skipping");
      return;
    }

    // Combine news from both sources
    const allNews = [];
    if (locationNews) {
      allNews.push(...locationNews);
    }
    if (generalNews) {
      allNews.push(...generalNews);
    }

    console.log("[NewsNotificationChecker] combined news", {
      allNewsLength: allNews.length,
      newsIds: allNews.map((n) => n.id),
    });

    if (allNews.length > 0) {
      checkForNewNews(allNews, locationId);
    } else {
      console.log("[NewsNotificationChecker] no news items, skipping API call");
    }
  }, [locationNews, generalNews, locationId, checkForNewNews]);

  // This component renders nothing - it's just for side effects
  return null;
};

export default NewsNotificationChecker;
